import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  FLAG_GETTING_ITINERARY_COUNTER_REPORTS,
  GET_ITINERARY_COUNTER_REPORTS,
  FLAG_ITINERARY_COUNTER_REPORT_ACTIVITY,
  GET_ITINERARY_COUNTER_REPORT,
  CLEAR_ITINERARY_COUNTER_REPORT,
} from '../types';
import { isErrorResponse } from '../../utils/error-handlers';
import { ITINERARY_COUNTER_REPORT_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG } from '../../config/rest';
import { ITINERARY_COUNTER_REPORT_PATH } from '../../config/paths';

const flagGettingItineraryCounterReports = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_ITINERARY_COUNTER_REPORTS,
    payload: flag,
  });

const getItineraryCounterReports =
  (query = {}) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingItineraryCounterReports(true));
      const url = `${ITINERARY_COUNTER_REPORT_ENDPOINT}?${QueryString.stringify(
        query,
      )}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const itineraryCounterReports = await response.json();
      dispatch({
        type: GET_ITINERARY_COUNTER_REPORTS,
        payload: itineraryCounterReports,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingItineraryCounterReports(false));
    }
  };

const flagItineraryCounterReportActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ITINERARY_COUNTER_REPORT_ACTIVITY,
    payload: flag,
  });

const postItineraryCounterReport = (filters) => async (dispatch) => {
  try {
    dispatch(flagItineraryCounterReportActivity(true));
    const response = await fetch(ITINERARY_COUNTER_REPORT_ENDPOINT, {
      ...DEFAULT_POST_CONFIG,
      body: JSON.stringify(filters),
    });
    await isErrorResponse(response, null, dispatch);
    const itineraryCounterReport = await response.json();
    dispatch(
      push(`${ITINERARY_COUNTER_REPORT_PATH}/${itineraryCounterReport.id}`),
    );
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagItineraryCounterReportActivity(false));
  }
};

const getItineraryCounterReport =
  ({ itineraryCounterReportId }) =>
  async (dispatch) => {
    try {
      dispatch(flagItineraryCounterReportActivity(true));
      const url = `${ITINERARY_COUNTER_REPORT_ENDPOINT}/${itineraryCounterReportId}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const itineraryCounterReport = await response.json();
      dispatch({
        type: GET_ITINERARY_COUNTER_REPORT,
        payload: itineraryCounterReport,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagItineraryCounterReportActivity(false));
    }
  };

const clearItineraryCounterReport = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_COUNTER_REPORT,
  });

export {
  flagGettingItineraryCounterReports,
  getItineraryCounterReports,
  flagItineraryCounterReportActivity,
  postItineraryCounterReport,
  getItineraryCounterReport,
  clearItineraryCounterReport,
};
